import type { RouteObject } from 'react-router';
import { AuthCallback } from '@/auth/AuthCallback';
import { GamesPage } from '@/grid/GamesPage';
import { GridIndex, GridPage } from '@/grid/GridPage';
import { AppShell } from '@/layout/AppShell';
import { MODULES } from '@/modules';
import { HomePage } from '@/pages/HomePage';
import { ModulePage } from '@/pages/ModulePage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'grid', element: <GridIndex /> },
      { path: 'grid/:slug', element: <GridPage /> },
      { path: 'games', element: <GamesPage /> },
      // Forge pulls in the board and markdown libraries, so it loads on first visit.
      { path: 'forge', lazy: async () => ({ Component: (await import('@/forge/ForgePage')).ForgePage }) },
      { path: 'forge/ideas/:id', lazy: async () => ({ Component: (await import('@/forge/IdeaPage')).IdeaPage }) },
      { path: 'cycles', lazy: async () => ({ Component: (await import('@/cycles/CyclesPage')).CyclesIndex }) },
      { path: 'cycles/:slug', lazy: async () => ({ Component: (await import('@/cycles/CyclesPage')).CyclesPage }) },
      { path: 'scan', lazy: async () => ({ Component: (await import('@/scan/ScanPage')).ScanPage }) },
      // Comms pulls in markdown rendering, so it loads on first visit.
      { path: 'comms', lazy: async () => ({ Component: (await import('@/comms/CommsPage')).CommsIndex }) },
      { path: 'comms/:channel', lazy: async () => ({ Component: (await import('@/comms/CommsPage')).CommsPage }) },
      { path: 'vault', lazy: async () => ({ Component: (await import('@/vault/VaultPage')).VaultPage }) },
      // Modules a later phase builds show a placeholder until then.
      ...MODULES.filter((m) => m.phase > 5).map((m) => ({
        path: m.path.slice(1),
        element: <ModulePage module={m} />,
      })),
      // Browser sign-in lands here; supabase-js has already finished it by the time we render.
      { path: 'auth/callback', element: <AuthCallback /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
